import { toPlatePlugin } from '@udecode/plate/react';

import { BaseSubscriptPlugin } from '../lib/BaseSubscriptPlugin';

export const SubscriptPlugin = toPlatePlugin(BaseSubscriptPlugin);
